import { Injectable } from '@angular/core';

@Injectable({
  providedIn: 'root'
})
export class ComponentService {
  constructor() { }

  public getDynamicInputType(input: { type: string, value: any, options?: string[] }): { type: string, value: any, options?: string[] } {
    return input;
  }
}
